import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCargoItems(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEMS,
		options
	)
}

function _getCargoItem(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM,
		options
	)
}

function _createCargoItem(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].CREATE_CARGO_ITEM,
		options
	)
}

function _putCargoItem(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].PUT_CARGO_ITEM,
		options
	)
}

function _patchCargoItem(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].PATCH_CARGO_ITEM,
		options
	)
}

function _deleteCargoItem(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].DELETE_CARGO_ITEM,
		options
	)
}

function _getCargoItemPreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_PREVIEW,
		options
	)
}

function _getCargoItemPopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.CARGO_ITEMS,
		ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_POPUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEMS]: _getCargoItems,

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM]: _getCargoItem,
	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_PREVIEW]: _getCargoItemPreview,
	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].GET_CARGO_ITEM_POPUP]: _getCargoItemPopup,

	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].CREATE_CARGO_ITEM]: _createCargoItem,
	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].PUT_CARGO_ITEM]: _putCargoItem,
	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].PATCH_CARGO_ITEM]: _patchCargoItem,
	[ModulesConfigMap[ModulesMap.CARGO_ITEMS].DELETE_CARGO_ITEM]: _deleteCargoItem,
}